import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import CloseJobDescriptionForm from './CloseJobDescriptionForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const CloseJobDescriptionModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeCloseJobDescriptionModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.closeJobDescriptionModalIsOpen}
      contentLabel={'Close Job Description'}
      onRequestClose={() => {
        closeCloseJobDescriptionModal();
      }}
    >
      <PageTitle text={'Close Job Description'} />
      <CloseJobDescriptionForm />
    </StandardModal>
  );
};

export default CloseJobDescriptionModal;
